<template>
  <div class="container-fluid">
    <div class="header">
      <h3>Thrive Through Change Growth Mindset Quiz</h3>
    </div>

    <div class="container-fluid box">
      <div class="row">
        <div class="col-md-6 col-xs-12" id="results-left">
          <div class="row">
            <div class="col-3" style="text-align:center;">
              <img class="img-fluid header-image" src="@/assets/asset_result_left.png">
              <h1 id="fixed">{{fixedScore}}</h1>
              <p class="fixed-score-label">Your Fixed
                <br>Mindset Score
              </p>
            </div>
            <div class="col-6" style="text-align:center;">
              <img class="img-fluid header-image" src="@/assets/asset_result_center.png">
            </div>

            <div class="col-3" style="text-align:center;">
              <img class="img-fluid header-image" src="@/assets/asset_result_right.png">
              <h1 id="growth">{{growthScore}}</h1>
              <p class="growth-score-label">Your Growth
                <br>Mindset Score
              </p>
            </div>
          </div>

          <br>
          <div class="container-fluid">
            <b-progress class="progresso" :value="major" :max="max"></b-progress>
          </div>
          <div class="row">
            <div class="col-6" style="text-align:left; padding:10px 0 0 30px;">FIXED</div>

            <div class="col-6" style="text-align:right;padding:10px 30px 0 0;">GROWTH</div>
          </div>
          <br>
          <br>
          <div class="container-fluid">
            <p>
              Our mindsets exist on a continuum from fixed to growth. Although
              we’d like to always have a growth mindset, the reality is that we can
              only be on a journey to a growth mindset. The goal is to recognize
              fixed mindset tendencies in ourselves and then reflect on feedback
              and strategies to improve.
            </p>
          </div>
        </div>

        <div class="col-md-6 col-xs-12" id="results-right">
          <div>
            <h2 class="text-center">Which score is higher?</h2>
          </div>
          <br>
          <div>
            <p>
              Use your scores as a benchmark to track your progress over the
              coming weeks and months. As you make a habit of embracing a
              growth mindset, you will see that score go up and your fixed mindset
              score go down.
            </p>
          </div>
          <br>
          <div class="doMore">
            <h4>DO MORE:</h4>
          </div>

          <div>
            <h5>Believing that you can always improve.</h5>
          </div>
          <div>
            <h5>Seeing opportunities in the challenge.</h5>
          </div>
          <div>
            <h5>Using change to develop your strengths and overcome weaknesses.</h5>
          </div>
          <br>
          <div class="doLess">
            <h4>DO LESS:</h4>
          </div>

          <div>
            <h5>Believe you have it, or you don’t.</h5>
          </div>
          <div>
            <h5>Feeling threatened by change.</h5>
          </div>
          <div>
            <h5>Worrying when change reveals a weakness.</h5>
          </div>
          <br>
          <div>
            <div id="quiz-controls">
              <button
                style="background-color: #0082c4;"
                type="button"
                v-on:click="clear"
                class="btn btn-lg btn-primary"
              >Retake Quiz</button>
              <button
                style="background-color: #0082c4;"
                type="button"
                v-on:click="onPrint"
                class="btn btn-lg btn-primary"
              >Print Results</button>
            </div>
          </div>
          <div class="week1 text-center">
            <a
              class="text-center"
              style="text-decoration: underline; color: #0070BC; "
              href="https://iris.cigna.com/you/empowered/careergrowth/thrive_through_change/week1"
              target="_blank"
            >Close quiz and take me back to Thrive Through Change Week 1</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Result",
  props: {
    msg: String
  },
  data: function() {
    return {
      answers: [], // we use it to keep the response loaded in memory
      fixedScore: 0, // initialize the fixedScore and growthScore variable
      growthScore: 0,
      major: 0, // initialize the major variable
      max: 100 // initialize the maximum value of the proggress bar
    };
  },
  methods: {
    /**
     * This method executes the action of printing the results
     */
    onPrint() {
      console.log("print");
      window.print();
    },

    /**
     * clear the answers
     */
    clear() {
      for (var i = 1; i <= this.answers.length; i++) {
        this.answers[i - 1].answer = 1;
      }
      localStorage.setItem("answers", JSON.stringify(this.answers));
      this.$router.push({ name: "home" });
    },

    /**
     * This method calculates the results
     */
    calculate() {
      console.log("print");

      // cycle that goes through the answer and calculates the results
      for (var i = 1; i <= this.answers.length; i++) {
        console.log(this.answers[i - 1]);

        // conditional that verifies which of the questions belongs to the fixedScore
        // if not, it belongs to growthScore
        if (i == 1 || i == 4 || i == 5 || i == 8 || i == 9) {
          this.fixedScore += this.answers[i - 1].answer;
        } else {
          // summation of the results
          this.growthScore += this.answers[i - 1].answer;
        }
      }

      // Updated progress bar code
      this.major =
        (this.fixedScore / (this.fixedScore + this.growthScore)) * 100;

      // Code for Google event tracking.
      var resultType = "equal";

      // we assign the highest
      if (this.growthScore > this.fixedScore) {
        resultType = "growth";
        //this.major = this.growthScore;
      } else {
        resultType = "fixed";
        //this.major = this.fixedScore;
      }
      console.log(resultType);
      gtag("event", "quizComplete", {
        event_category: "quizScore",
        event_label: resultType,
        transport_type: "beacon"
      });
    }
  },
  mounted() {
    console.log("App mounted!");
    // we get in memory the responses stored in localstorage
    if (localStorage.getItem("answers"))
      this.answers = JSON.parse(localStorage.getItem("answers"));
    this.calculate(); // we calculate the results
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.divisor {
  background: #0070bc;
  width: 5px;
  height: 100%;
  margin: auto;
  border-radius: 5px;
}
.box {
  padding-top: 20px;
}

.header {
  background: #0070bc;
  font-style: italic;
  color: white;
  min-height: 43px;
}
.header h3 {
  padding-top: 10px;
  font-weight: 600;
  font-size: 20px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

#results-left,
#results-right {
  text-align: left;
  font-size: 16px;
  line-height: 20px;
  padding: 0 30px 0 20px;
}

#results-right {
  border-left: solid 1px #0070bc;
  border-top: none !important;
  padding: 0 20px 0 30px;
}
.header-image {
  margin-bottom: 20px;
}

h1 {
  color: #7db361;
  font-size: 96px;
  font: 900;
}
a {
  color: #7db361;
}
.progresso.progress {
  background-color: #00426d;
}
.progresso.progress .progress-bar {
  background-color: #7cc6ea !important;
}
.classify p {
  font-size: 13px;
  font-style: italic;
}

.doMore h4 {
  font-size: 21px;
  color: #00426d;
  font-weight: bold;
  padding-bottom: 10px;
}
.doLess h4 {
  font-size: 21px;
  color: #00426d;
  font-weight: bold;
  padding-bottom: 10px;
}
h5 {
  font-size: 15px;
  line-height: 18px;
  color: black;
  font-weight: bold;
}
p {
  text-align: left;
}

.btn-primary {
  background-color: #0082c4 !important;
  min-width: 100px;
  margin: 0 10px 10px 10px;
}
#quiz-controls {
  text-align: center;
  margin: 20px auto;
  border-top: solid 1px #0082c4;
  padding: 20px;
}
@media screen and (max-width: 900px) {
  #fixed,
  #growth {
    font-size: 3rem;
  }
}
@media screen and (max-width: 767px) {
  #fixed,
  #growth {
    font-size: 5rem;
  }
}
@media screen and (max-width: 441px) {
  #fixed,
  #growth {
    font-size: 3rem;
  }
}
.fixed-score-label {
  text-align: left;
  padding-left: 5%;
}
.growth-score-label {
  text-align: right;
  padding-right: 5%;
}
/*  /*iPhone 6/7/8pluses* /Media Query */
@media only screen and (min-device-width: 411px) and (max-device-width: 736px) and (orientation: portrait) {
  .divisor {
    height: 10px;
    margin: auto;
    width: 100%;
    margin-bottom: 15px;
    margin-top: 15px;
  }
  .header h3 {
    padding-top: 13px;
    font-size: 17px;
  }
}

@media screen and (max-width: 767px) {
  #results-right {
    border-top: solid 1px #0070bc !important;
    border-left: none !important;
  }
  #results-left,
  #results-right {
    padding: 20px;
  }
}
</style>